import gql from "graphql-tag";

export const DOCUMENT_MANY = gql(/* GraphQL */ `
  query CitationDocumentMany($documentIds: [Int!]!) {
    documentMany(ids: $documentIds) {
      id
      name
      signedUrl
    }
  }
`);

export const NOTE_MANY = gql(/* GraphQL */ `
  query CitationNoteMany($noteIds: [Int!]!) {
    notesMany(ids: $noteIds) {
      id
      text
      noteDate
    }
  }
`);
